import EmbeddedCardLayout from '../../../components/embedded/CardLayout';
import EmbeddedLoadingState, {
  EmbeddedLoadingStateHelp,
} from '../../../components/embedded/LoadingState';
import { useTranslation } from '../../../i18n/i18n';

/** Loading: placeholder tiles, no button row, like the app list it becomes. */
export default function EmbeddedLoadingPage() {
  const { t } = useTranslation();
  return (
    <EmbeddedCardLayout buttonRow={false} help={<EmbeddedLoadingStateHelp />}>
      <EmbeddedLoadingState label={t('embedded.loading')} />
    </EmbeddedCardLayout>
  );
}
